import { generatePath } from 'react-router-dom';
import { MARKET_LIST } from 'routes';

export function marketListPage(): string {
  return generatePath(MARKET_LIST);
}
